import { Link } from 'gatsby'
import React from 'react'
import { PageNumbers } from './page_numbers'
import { ButtonLink, PaginationFlex, Wrapper } from './style'

const Pagination = ({ pageContext }: any) => {
  const { currentPage, numPages, localePath } = pageContext

  const pages = new PageNumbers({ currentPage: currentPage, totalPages: numPages }).getPages()

  const isFirst = currentPage === 1
  const isLast = currentPage === numPages

  // Paths
  const prevPagePath =
    currentPage - 1 === 1
      ? `${localePath}/page/1`
      : `${localePath}/page/` + (currentPage - 1).toString()
  const nextPagePath = `${localePath}/page/` + (currentPage + 1).toString()
  const firstPagePath = `${localePath}/page/1`
  const lastPagePath = `${localePath}/page/${numPages}`
  const getPageNumberPath = (currentIndex: any) => {
    if (currentIndex === 1) {
      return `${localePath}/page/1`
    }
    return `${localePath}/page/` + currentIndex
  }

  // ClassNames
  const prevPageClassName = isFirst ? 'disabledButton' : 'button'
  const nextPageClassName = isLast ? 'disabledButton' : 'button'

  return (
    <Wrapper>
      <ButtonLink>
        <a href="#top" rel="back-to-top" className="button">
          Back to top
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path
              fillRule="evenodd"
              d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>
        </a>
      </ButtonLink>
      <PaginationFlex>
        <ButtonLink>
          <Link className={prevPageClassName} to={firstPagePath} rel="first">
            First
          </Link>
        </ButtonLink>
        <ButtonLink>
          <Link className={prevPageClassName} to={prevPagePath} rel="prev">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Prev
          </Link>
        </ButtonLink>
        {pages.map((page: any, index: number) => {
          let pageNumberClassName = 'pageNumber'
          if (currentPage === page) {
            pageNumberClassName = 'currentPageNumber'
          }
          if (page === '...') {
            pageNumberClassName = 'disabledButton'
          }
          return (
            <ButtonLink key={index}>
              <Link className={pageNumberClassName} to={getPageNumberPath(page)}>
                {page}
              </Link>
            </ButtonLink>
          )
        })}
        <ButtonLink>
          <Link className={nextPageClassName} to={nextPagePath} rel="next">
            Next
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </Link>
        </ButtonLink>
        <ButtonLink>
          <Link className={nextPageClassName} to={lastPagePath} rel="last">
            Last
          </Link>
        </ButtonLink>
      </PaginationFlex>
    </Wrapper>
  )
}

export default Pagination
